import { Text } from '@cuemath/web-comps';
import React from 'react';

export default function Heading({ children }) {
  return <Text variant="h6">{children}</Text>;
}
